<template>
  <div class="" v-if="authority && authority.length > 0">
    <a-tree
      :tree-data="authority"
      checkable
      @select="handleSelectAuthority"
      :show-icon="true"
      :show-line="true"
      :replace-fields="{
        children: 'children',
        title: 'name',
        key: 'id',
      }"
    >
      <template #icon>
        <ClusterOutlined />
      </template>
    </a-tree>
  </div>
</template>

<script>
import { defineComponent, reactive, watch } from "vue";

export default defineComponent({
  props: { treeData: Object },
  setup(props, context) {
    const authority = reactive([]);

    const handleSelectAuthority = () => {};

    watch(
      () => props.treeData,
      (val) => {
        authority.length = 0;
        authority.push(...val);
        console.log(val, "+++++++++++++");
      },
      {
        immediate: true,
        deep: true,
      }
    );
    return {
      authority,
      handleSelectAuthority,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
